module.exports = __webpack_public_path__ + "static/media/44.2ab2c670.jpg";